var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8186_734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2354 7.49684C11.2354 8.11086 11.7288 8.5933 12.3319 8.5933H18.461L6.52066 20.5337C6.09305 20.9613 6.09305 21.6521 6.52066 22.0797C6.94828 22.5073 7.63905 22.5073 8.06666 22.0797L20.007 10.1393V16.2685C20.007 16.8715 20.5004 17.3649 21.1035 17.3649C21.7065 17.3649 22.2 16.8715 22.2 16.2685V7.49684C22.2 6.89379 21.7065 6.40039 21.1035 6.40039H12.3319C11.7288 6.40039 11.2354 6.89379 11.2354 7.49684Z",
    fill: "#11334E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8186_734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(2.40015 2.40039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.0c6928634dd755d7617ab8f4695ca368.svg";
export { ForwardRef as ReactComponent };